const FormSuccess = ({ children }: { children: JSX.Element | string }) => {
  return (
    <p className="text-sm font-semibold tablet:text-base text-success">
      {children}
    </p>
  );
};

export default FormSuccess;
